module.exports = __webpack_public_path__ + "static/img/y37.e5f633c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y37.jpg
// module id = Ws2k
// module chunks = 1